export default {
    sales: "sales@autowizapp.com",
    info: "info@autowizapp.com"
}